import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Collection from './components/Users';
import Object from './components/user';
import FERadiusMap from "./components/RadiusMap";

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import UserRoles, {USER_DIRECTORY_ROLES} from "constants/UserRoles";


/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, regions, roles}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute path={`${match.url}/:id(\\d+)`}>
				<Object regions={regions} roles={roles} baseUrl={match.url}/>
			</ErrorBoundaryRoute>

			{roles.some(role => [...USER_DIRECTORY_ROLES, UserRoles.Developer].includes(role)) &&
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>
			}

			{roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Developer, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) &&
				<ErrorBoundaryRoute exact path={`${match.url}/feradius`}>
					<FERadiusMap regions={regions} roles={roles}/>
				</ErrorBoundaryRoute>
			}

			{roles.includes(UserRoles.Dispatch) && <ErrorBoundaryRoute><Redirect to="/dispatch"/></ErrorBoundaryRoute>}
			{roles.includes(UserRoles.FieldEngineer) && <ErrorBoundaryRoute><Redirect to="/engineers"/></ErrorBoundaryRoute>}
			{roles.includes(UserRoles.Admin) && <ErrorBoundaryRoute><Redirect to="/admins"/></ErrorBoundaryRoute>}
		</Switch>
	</div>
);
